export const CUSTOM_PREFERENCE_CENTER_FEATURE = 'customPreferenceCenter';
export const CUSTOM_PREFERENCE_CENTER_CORE_FEATURE = 'customPreferenceCenterCore';
